import React, { ReactChild, ReactChildren } from 'react';

const TableHeader = ({ children }: { children: ReactChild | ReactChildren }) => {
   return <thead>{children}</thead>;
};

export default React.memo(TableHeader);
